import React from "react"

const NoDataFound = (props) => {
  return (
    <div className="text-center">
        <div style={{ paddingTop: "0px" }}>{props.text}</div>
        <img alt='' src="/kshemaImages/no_data_found.jpg"></img>
    </div>
  )
};

export default NoDataFound;